// A2-537 U17 — where a country form was opened from.
//
// "Back to calc" went to `/?calc_id=…`, which resumes the calc at its
// latest step (Step 6), so a form opened from Step 4's "To file this
// return" list sent the operator two steps on. Every link that opens a
// form passes this as router state and the form's back button returns
// there. A form opened from another form's tab keeps the first origin,
// so switching countries does not turn "Back" into "previous country".
export const returnState = (location) => ({
  from: location?.state?.from || `${location?.pathname || ""}${location?.search || ""}`,
});
